import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["disabled", "placeholder"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "gfu-field-select__content-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-field-select__group-header"
}
const _hoisted_6 = { class: "gfu-field-select__group-header" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_toggle_trigger = _resolveComponent("toggle-trigger")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_toggle_content = _resolveComponent("toggle-content")
  const _component_toggle_container = _resolveComponent("toggle-container")
  const _component_field = _resolveComponent("field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "gfu-grid__cell",
        "data-qa": `filtersbox-field:${_ctx.displayName}`
      }, [
        _createVNode(_component_field, _mergeProps({..._ctx.fieldAttrs, ..._ctx.$props}, { small: true }), {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['gfu-field-auto-complete__container', $options.autoCompleteChevronClasses])
            }, [
              ($props.isReadOnly)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    readonly: true,
                    disabled: $props.isReadOnly,
                    placeholder: $options.placeholder,
                    class: "gfu-field__input gfu-field__input--small",
                    onFocus: _cache[0] || (_cache[0] = (...args) => ($options.onInputFocus && $options.onInputFocus(...args))),
                    "data-qa": "auto-complete-input"
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2))
                : (_openBlock(), _createBlock(_component_toggle_container, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_toggle_trigger, {
                        ref: "toggleTrigger",
                        tag: "div",
                        tabindex: "0",
                        "active-class": "gfu-field-select__trigger--active",
                        "handle-click": false,
                        "focus-children": true,
                        onCollapse: $options.onCollapse
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchTerm) = $event)),
                            placeholder: $options.placeholder,
                            class: "gfu-field__input gfu-field__input--small",
                            onFocus: _cache[2] || (_cache[2] = (...args) => ($options.onInputFocus && $options.onInputFocus(...args))),
                            "data-qa": "auto-complete-input"
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
                            [_vModelText, $data.searchTerm]
                          ]),
                          ($data.oldIDs.length && !$props.isReadOnly)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "gfu-field-auto-complete__clear gfu-field-auto-complete__clear--small gfu-btn",
                                onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.onClickClear && $options.onClickClear(...args)), ["stop"])),
                                "data-qa": "input-clear"
                              }, [
                                _createVNode(_component_base_icon, { name: "times" })
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onCollapse"]),
                      _createVNode(_component_toggle_content, {
                        tag: "div",
                        tabindex: "1",
                        class: "gfu-field-select__content",
                        "active-class": "gfu-field-select__content--expanded",
                        "data-qa": "select-content"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            ($options.selectedItems.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.selectedGroupTitle), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectedItems, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `items-filter-checkbox-${item.value}`,
                                "data-qa": "selected-items"
                              }, [
                                _createVNode(_component_checkbox_field, {
                                  modelValue: $data.oldIDs,
                                  "onUpdate:modelValue": [
                                    _cache[4] || (_cache[4] = $event => (($data.oldIDs) = $event)),
                                    $options.handleInput
                                  ],
                                  "display-name": item.name,
                                  "checked-value": item.value,
                                  inline: true,
                                  disabled: !$options.canSelectMoreItems && !$options.isItemSelected(item.value),
                                  condensed: true,
                                  "data-qa": `items-filter-checkbox:${item.value}`
                                }, null, 8 /* PROPS */, ["modelValue", "display-name", "checked-value", "disabled", "onUpdate:modelValue", "data-qa"])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createElementVNode("div", _hoisted_6, _toDisplayString($options.groupTitleLabel), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.pagedFilteredItems, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `items-filter-checkbox-${item.value}`,
                                "data-qa": "other-items"
                              }, [
                                _createVNode(_component_checkbox_field, {
                                  modelValue: $data.newIDs,
                                  "onUpdate:modelValue": [
                                    _cache[5] || (_cache[5] = $event => (($data.newIDs) = $event)),
                                    $options.handleInput
                                  ],
                                  "display-name": item.name,
                                  "checked-value": item.value,
                                  inline: true,
                                  disabled: !$options.canSelectMoreItems && !$options.isItemSelected(item.value),
                                  condensed: true,
                                  "data-qa": `items-filter-checkbox:${item.value}`
                                }, null, 8 /* PROPS */, ["modelValue", "display-name", "checked-value", "disabled", "onUpdate:modelValue", "data-qa"])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */)),
                            ($options.canLoadMoreFilteredItems)
                              ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                                  key: 1,
                                  onLoadMore: $options.loadMoreFilteredItems
                                }, null, 8 /* PROPS */, ["onLoadMore"]))
                              : _createCommentVNode("v-if", true),
                            _createVNode(_component_progress_overlay, {
                              visible: _ctx.isProcessing,
                              sticky: true
                            }, null, 8 /* PROPS */, ["visible"])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */)
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}